import { render, staticRenderFns } from "./_alias.vue?vue&type=template&id=453f1c8d&"
import script from "./_alias.vue?vue&type=script&lang=js&"
export * from "./_alias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports